export const PAGE_KEYS = {
    BALLOT_PAGE: 'ballot',
    CANDIDATE_PAGE: 'kandidater',
    PREVIEW_PAGE: 'preview',
    TESTMINKONTO_PAGE: 'testminkonto',
} as const;

export const BODY_OVERFLOW_HIDDEN_CLASS = 'body-overflow-hidden';
